import type { NextPage } from 'next';
import MainLayout from '../components/layouts/MainLayout';
import { useTranslation } from "next-i18next";
import { GetServerSideProps } from 'next';
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTheme } from '@mui/material/styles';

import PolicySection from '../components/sections/policy/PolicySection';

interface IPolicyProps {
    content: string;
    locale: string;
}

const Policy: NextPage<IPolicyProps> = (props: IPolicyProps) => {
    const theme = useTheme();
    const { t } = useTranslation('policy');

    return (
        <MainLayout
            {...props}
            title={t('PolicySection.title')}
            description={t('PolicySection.subtitle')}
            keywords={t('PolicySection.keywords')}
        >
            <PolicySection {...props} />
        </MainLayout>
    )
}

export default Policy;


export const getServerSideProps: GetServerSideProps = async (context) => {
    const fs = (await import('fs'));
    const locale = context.locale as string;
    const content = fs.readFileSync(`policy/${locale}.md`, 'utf8');

    return {
        props: {
            content,
            locale,
            ...(await serverSideTranslations(locale, ['common', 'policy'])),
        }
    }
}